import { DealerTimecard } from './dealer.timecard';
import { UUID } from './uuid';
export class Dealer {
  public id: UUID;
  public name: string;
  public is_active: boolean;
  public timecards: DealerTimecard[];
}
